import CloudAccounts from './CloudAccounts';

export default CloudAccounts;
